import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getDepartmentsCall,
  getDepartmentTeamsCall,
  getDepartmentTeamMembersCall,
  getDepartmentTeamDetailsCall,
  getDepartmentsCreditsCall,
  getDepartmentsCreditsQuarterCall,
  getDepartmentTeamCreditsCall,
  getDepartmentTeamCreditsQuarterCall,
  getDepartmentMembersCall,
  postCreateDepartmentCall,
  postAssignDepartmentCall,
  postAssignCheckCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getDepartmentsCall.saga,
  getDepartmentTeamsCall.saga,
  getDepartmentTeamMembersCall.saga,
  getDepartmentTeamDetailsCall.saga,
  getDepartmentsCreditsCall.saga,
  getDepartmentsCreditsQuarterCall.saga,
  getDepartmentTeamCreditsCall.saga,
  getDepartmentTeamCreditsQuarterCall.saga,
  getDepartmentMembersCall.saga,
  postCreateDepartmentCall.saga,
  postAssignDepartmentCall.saga,
  postAssignCheckCall.saga,
];

export function* departmentsRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
